module.exports = __webpack_public_path__ + "pc/img/emotion_share.12befc93.png";